import Cookies from 'universal-cookie';
import { User } from '../models/userSettings';
import CookieKey from './enums';
import { getDefaultCookieOptions } from './defaultOptions';

const cookies = new Cookies();
const maxCookieAge = 31536000; // 1 year

export const storeUserDetails = (user: User): void => {
  const userCookieOptions = {
    ...getDefaultCookieOptions(),
    maxAge: maxCookieAge,
  };

  cookies.set(CookieKey.USER_ID, user.id, userCookieOptions);

  if (user.people?.length > 0) {
    // In local development we seed the db with MMELS operator for MEL.
    // This operator can break certain pages because no data exists for the operator.
    // Adding this filter to remove it for now
    if (
      process.env.NODE_ENV === 'development' &&
      user.people.some((person) => person.organisation.name === 'MMELs')
    ) {
      const filteredPeople = user.people.filter((person) => person.organisation.name !== 'MMELs');
      cookies.set(CookieKey.ORGANISATION_ID, filteredPeople[0].organisation.id, userCookieOptions);
    } else {
      cookies.set(CookieKey.ORGANISATION_ID, user.people[0].organisation.id, userCookieOptions);
    }
  }
};

export const removeUserDetails = (): void => {
  const cookieOptions = getDefaultCookieOptions();

  cookies.remove(CookieKey.USER_ID, cookieOptions);
  cookies.remove(CookieKey.ORGANISATION_ID, cookieOptions);

  /**
   * These cookies are no longer stored as of about 19/09/2025 but we continue to remove them
   * for browsers that may still have them from before the cookie management refactor.
   *
   * We should be able to remove these after a few months.
   */
  cookies.remove(CookieKey.USER_FULL_NAME, cookieOptions);
  cookies.remove(CookieKey.USER_AUTHORITY, cookieOptions);
};

export const getUserId = (): string => {
  return cookies.get(CookieKey.USER_ID);
};

export const getOrgId = (): string => {
  return cookies.get(CookieKey.ORGANISATION_ID);
};
